import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  legendContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: 84,
    marginTop: 12
  }
})

export default useStyles
